export class LoginModel {

  public email: string;
  public password: string;
  public rememberMe: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/user/login-model.ts